import { render, staticRenderFns } from "./idsec.vue?vue&type=template&id=6d55f6ad&scoped=true&"
import script from "./idsec.vue?vue&type=script&lang=js&"
export * from "./idsec.vue?vue&type=script&lang=js&"
import style0 from "./idsec.vue?vue&type=style&index=0&id=6d55f6ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d55f6ad",
  null
  
)

export default component.exports